module.exports = __webpack_public_path__ + "assets/img/04.d79f1947.png";